import Student from './Student.container';

export default Student;
